/* eslint-disable */

import pinia from "@/store";
import axios from "./downloadAxios";
import { useUserStore } from "@/store";
import axiosSSO from "./downloadAxiosSSO";
import axiosXXL from "./downloadAxiosXXL";
import axiosMETA from "./downloadAxiosMETA";
import axiosBJH from "./downloadAxiosBJH";
import axiosXHS from "./downloadAxiosXHS";
import axiosTUWEN from "./downloadAxiosTUWEN";

const store = useUserStore(pinia);

// const XLSX = require('./xlsx')
const XLSX = await import("xlsx");


export function s2ab(s: any) { // 字符串转字符流
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== s.length; i += 1) {
    view[i] = s.charCodeAt(i) & 0xFF; // eslint-disable-line no-bitwise
  }
  return buf;
}

export function getCharCol(n: any) { // 将指定的自然数转换为26进制表示。映射关系：[0-25] -> [A-Z]。
  let s = "";
  let m = 0;
  while (n > 0) {
    m = n % 26 + 1;
    s = String.fromCharCode(m + 64) + s;
    n = (n - m) / 26;
  }
  return s;
}

export function changeData(val: any) {
  let value = "";
  if (!val && val != 0) {
    value = "";
  } else if (typeof val !== "object") {
    value = val;
  } else if (Array.isArray(val)) {
    let str = "";
    val.forEach(item => {
      if (typeof item !== "object") {
        str = str + item + ",";
      } else {
        str = str + JSON.stringify(item) + ",";
      }
    });
    value = str;
  } else {
    value = JSON.stringify(val);
  }
  return value;
}

// 获取数组或对象下的某一项
function childValue(val: any, list: any) {
  if (val) {
    let str = "";
    if (Array.isArray(val)) {
      // 判断是数组
      val.forEach((item, index) => {
        str = str + item[list[1]] + (val.length - 1 != index ? "," : "");
      });
      return str;
    } else {
      // 判断是对象
      return val[list[1]];
    }
  } else {
    return "";
  }
}

export function downloadExl(json: any, downName: any, type?: any) { // 导出到excel
  const keyMap: any = []; // 获取键
  for (const k in json[0]) {
    keyMap.push(k);
  }
  const tmpdata: any = []; // 用来保存转换好的json
  var d = new Date();
  tmpdata["A1"] = {
    v: "导出日期：" + d.toLocaleString()
  };
  json.map((v: any, i: any) => keyMap.map((k: any, j: any) => {
    if (k.includes(".") && i > 0) {
      const arr = k.split(".");
      return Object.assign({}, {
        v: childValue(v[arr[0]], arr),
        position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1 + 1)
      });
    } else {
      return Object.assign({}, {
        v: v[k],
        position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1 + 1)
      });
    }
  })).reduce((prev: any, next: any) => prev.concat(next)).forEach(function(v: any) {
    tmpdata[v.position] = {
      v: changeData(v.v)
    };
  });
  const outputPos = Object.keys(tmpdata); // 设置区域,比如表格从A1到D10
  const tmpWB = {
    SheetNames: ["mySheet"], // 保存的表标题
    Sheets: {
      "mySheet": Object.assign({},
        tmpdata, // 内容
        {
          "!ref": outputPos[0] + ":" + outputPos[outputPos.length - 1] // 设置填充区域
        })
    }
  };
  const tmpDown: any = new Blob([s2ab(XLSX.write(tmpWB,
    { bookType: (type === undefined ? "xlsx" : type), bookSST: false, type: "binary" } // 这里的数据是用来定义导出的格式类型
  ))], {
    type: ""
  }); // 创建二进制对象写入转换好的字节流
  let outFile = document.createElement("a");
  outFile.download = downName + ".xlsx"; // 下载名称
  outFile.href = URL.createObjectURL(tmpDown); // 创建对象超链接// 绑定a标签
  outFile.click(); // 模拟点击实现下载
  setTimeout(function() { // 延时释放
    URL.revokeObjectURL(tmpDown); // 用URL.revokeObjectURL()来释放这个object URL
    store.setLoading(false);
  }, 100);
}

export async function downloadFileV2(fileName, tableColumns, func, queryParams, totalCount) {
  if (totalCount !== undefined && totalCount > 0) {
    let progress = 0;
    this.loading = true;
    let list = [];
    const max_i = totalCount <= 1000 ? 1 : Math.ceil(totalCount / 1000);
    try {
      for (let i = 0; i < max_i; i++) {
        const resp = await func({ ...queryParams, isMask: true, page: i + 1, limit: 1000 });
        list = list.concat(resp.data.items);
        progress += 100 / (max_i + 1);
        //loading.setText('下载中' + progress + '%')
      }

      let data = [{}];
      for (const k in tableColumns) {
        data[0][k] = tableColumns[k];
      }
      data = data.concat(list);
      downloadExl(data, fileName);
      this.loading = false;
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  } else {
    this.$message.error("没有要导出的数据");
  }
}
